import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';

const StyledRadio = withStyles({
  root: {
    backgroundColor: 'transparent',
    color: '#000',
    '&$checked': {
      color: '#000',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

function RadioContainer({name, value, onChange, options}) {
  return (
    <RadioGroup aria-label={name} name={name} value={value} onChange={onChange}>
        {
            options.map((val, index)=>{
                return(
                    <FormControlLabel 
                      key={index}
                      value={val.value} 
                      control={<StyledRadio />} 
                      label={<span className="default-label">{val.label}</span>} 
                    />
                )
            })
        }
    </RadioGroup>
  );
}

export default RadioContainer;
